<mat-checkbox
    [ngModel]="companySetting.value"
    (ngModelChange)="onToggle()"
    name="toggle-{{ companySetting?.setting?.name }}"
    >{{
        performanceNotificationsDisplayOptions[companySetting?.setting?.name]
            ? (performanceNotificationsDisplayOptions[companySetting?.setting?.name] | translate)
            : companySetting?.setting?.description
    }}</mat-checkbox
>
